import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderDeliveryDataSchema } from './ServicesProviderDeliveryData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderDelivery extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.physicalAddress = data.physicalAddress;
        this.support = data.support;
    }
    validateData(data) {
        const result = servicesProviderDeliveryDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderDelivery.validation', `ServicesProviderDelivery data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.DELIVERY,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.DELIVERY, ServicesProviderDelivery);

export { ServicesProviderDelivery };
//# sourceMappingURL=ServicesProviderDelivery.js.map
